import React from "react";

import { TOOLTIPS } from "@app/common/content";

import { TeamSettingModuleProps } from "./types";
import OnOffSetting from "../components/OnOffSetting";
import WorkspaceSettingsAccordion from "../components/WorkspaceSettingsAccordion";

const TeamSharingModule = ({
  onSettingUpdate,
  settings,
  workspaceIsInactive,
}: TeamSettingModuleProps) => {
  return (
    <WorkspaceSettingsAccordion
      title="Shared Reporting"
      subtitle="Determine how team data is shared across team members"
      sx={{ borderTop: "1px solid", borderColor: "shades.neutral.100" }}
    >
      <OnOffSetting
        title="Workspace Trends"
        subtitle="Allow all team members to view aggregate metrics and trends for the Workspace."
        locked={workspaceIsInactive || !settings.workspaceRollups.edit}
        isOn={settings.workspaceRollups.view}
        onChange={onSettingUpdate("workspaceRollups")}
        bottomDivider
        tooltip={workspaceIsInactive ? TOOLTIPS.upsell.upgradeToPro : undefined}
      />
      <OnOffSetting
        title="Team Trends"
        subtitle="Allow all team members to view aggregate metrics and trends for their team"
        locked={workspaceIsInactive || !settings.teamRollups.edit}
        isOn={settings.teamRollups.view}
        onChange={onSettingUpdate("teamRollups")}
        bottomDivider
        tooltip={workspaceIsInactive ? TOOLTIPS.upsell.upgradeToPro : undefined}
      />
      <OnOffSetting
        title="Team Report Access"
        subtitle="Allow all team members to view meeting reports for anyone in their team"
        locked={workspaceIsInactive || !settings.shareTeamData.edit}
        isOn={settings.shareTeamData.view}
        onChange={onSettingUpdate("shareTeamData")}
        tooltip={workspaceIsInactive ? TOOLTIPS.upsell.upgradeToPro : undefined}
      />
    </WorkspaceSettingsAccordion>
  );
};

export default TeamSharingModule;
